import ModalsLib from '../../../../lib/modals';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/tasks/daily/vip_deposit';
import Diamond from '../diamond';

export default () => {
    const {task} = useSelector(Selector);

    return (
        <div className="task">
            <div className="task-top">
                <div className="icon">
                    <img src={`${window.location.origin}/source/system/tasks/vip.png`} alt="Crypto Icon" />
                </div>
                <div className="title">High Roller Deposit</div>
            </div>
            <div className="task-info">
                <div className="descriptions">
                    Deposit $150+ in one transaction to unlock special VIP rewards.
                </div> 
                {(task.completed || task.redeemed) ? (
                    <div className="button-block completed">
                        Completed
                    </div>
                ) : (
                    <div className="button-block">
                        <div className="button" onClick={e => {
                            ModalsLib.open('wallet');
                        }}>
                            Deposit
                        </div>
                        <div className="diamonds">
                            <Diamond />
                            {task.reward}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}